var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVistas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "#1E98D7",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3244_3903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 8C3.59961 8 5.19961 4.8 7.99961 4.8C10.7996 4.8 12.3996 8 12.3996 8C12.3996 8 10.7996 11.2 7.99961 11.2C5.19961 11.2 3.59961 8 3.59961 8Z",
    fill: "#1E98D7",
    stroke: "#1E98D7",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 9.2C8.66255 9.2 9.1998 8.66274 9.1998 8C9.1998 7.33725 8.66255 6.8 7.9998 6.8C7.33706 6.8 6.7998 7.33725 6.7998 8C6.7998 8.66274 7.33706 9.2 7.9998 9.2Z",
    fill: "#1E98D7",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3244_3903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(3.2002 3.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVistas);
export default __webpack_public_path__ + "static/media/icon-vistas.25f334e268ea004e9f63917234173f7f.svg";
export { ForwardRef as ReactComponent };